import { mergeProps, splitProps } from "solid-js";
import classNames from "./classnames";
import { useButtonProps } from "solid-bootstrap-core";
import { useBootstrapPrefix } from "./ThemeProvider";
import { Dynamic } from "solid-js/web";
const defaultProps = {
    variant: "primary",
    active: false,
    disabled: false,
};
const Button = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), [
        "as",
        "bsPrefix",
        "children",
        "variant",
        "size",
        "active",
        "class",
    ]);
    const prefix = useBootstrapPrefix(local.bsPrefix, "btn");
    const [buttonProps, { tagName }] = useButtonProps({
        tagName: local.as,
        ...props,
    });
    return (<Dynamic component={tagName} {...buttonProps} {...props} class={classNames(local.class, prefix, local.active && "active", local.variant && `${prefix}-${local.variant}`, local.size && `${prefix}-${local.size}`, props.href && props.disabled && "disabled")}>
      {local.children}
    </Dynamic>);
};
export default Button;
